module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 7 – 2-a5aa572b770f7f346f19828bf9e0aaca.svg";